/**
 * Navigation Scroll Behavior
 * Handles the navigation's appearance and behavior during scroll
 */

export default function initNavScroll() {
  const nav = document.querySelector(".site_header");
  let lastScrollTop = 0;
  const scrollThreshold = 50; // Adjust this value to change when the nav appears/disappears

  if (!nav) return;

  // Initial state - transparent background
  nav.classList.add("nav-transparent");

  // Add scroll event listener
  window.addEventListener("scroll", () => {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    // At the top of the page
    if (currentScroll === 0) {
      nav.classList.remove("nav-visible", "nav-hidden");
      nav.classList.add("nav-transparent");
    }
    // Scrolling down
    else if (currentScroll > lastScrollTop && currentScroll > scrollThreshold) {
      nav.classList.remove("nav-visible");
      nav.classList.add("nav-hidden");
    }
    // Scrolling up
    else if (currentScroll < lastScrollTop) {
      nav.classList.remove("nav-transparent", "nav-hidden");
      nav.classList.add("nav-visible");
    }

    lastScrollTop = currentScroll;
  });
}

// Initialize the navigation scroll behavior
document.addEventListener("DOMContentLoaded", () => {
  initNavScroll();
});
